import React, { FC } from "react";
import { ILink } from "../../ActionsSelectors/Link";
import ProductReviews, { IFeedback } from "../ProductReviews/ProductReviews";
import { ProductTitle } from "../../DataDisplay/ProductTitle";
import BrandLogo from "../BrandLogo/BrandLogo";
import { IMediaBuilderProps } from "../../Utility/MediaBuilder";
import { THeading } from "../../../interfaces";

export interface IProductBrandProps {
  /**
   * Brand icon
   */
  iconData: IMediaBuilderProps;
  /**
   * Product brand name
   */
  brand?: ILink;
  /**
   * Product name
   */
  product?: ILink;
  /**
   * Feedback data with rating and reviews
   */
  feedback?: IFeedback;
  /**
   * Do we need to show reviews or not
   */
  showReviews?: boolean;
  /**
   * Heading tag
   */
  useHeading?: THeading;
}

/**
 * Template component for display basic product information.
 * Such as brand, product name, description and user feedback
 */
const ProductBrand: FC<IProductBrandProps> = ({
  iconData,
  product,
  brand,
  feedback,
  showReviews = true,
  useHeading,
}) => (
  <div className="d-none d-lgm-flex flex-column">
    <BrandLogo iconData={iconData} />
    <div className="product-intro mb-6">
      <ProductTitle
        variant="PDP"
        brandName={brand?.text}
        brandLink={{ href: brand?.href }}
        productName={product?.text}
        productLink={{ href: product?.href }}
        useHeading={useHeading}
      />
    </div>
    {showReviews && (
      <div className="pdp-main review-section">
        <ProductReviews
          rating={feedback?.rating}
          reviews={feedback?.reviews}
          link={feedback?.link}
        />
      </div>
    )}
  </div>
);

export default ProductBrand;
